import React, { FC, ReactNode } from 'react';
import { BoxV2 as Box, SxProps } from 'portal-commons';

interface TwoColumnGridProps {
  children: ReactNode;
  sx?: SxProps;
}

const TwoColumnGrid: FC<TwoColumnGridProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '24px',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default TwoColumnGrid;
